module.exports = __webpack_public_path__ + "media/images/vp/icon.sharebutton-1dd63fbcb88f2615a945ac08bf8500b9.png";